import { useState, useCallback } from 'react';
import { postCall } from '../utils/Network';


export const useGetProducts = () => {
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const fetchProducts = useCallback(async ({
        regionId,
        userType,
        token
    }) => {
        try {
            setLoading(true);
            setError(null);

            const data = {
                url: 'getProducts',
                bodyData: {
                    storeId: 4,
                    userType: Number(userType),
                    currencyCode: "USD",
                    regionId: Number(regionId),
                },
                header: { Authorization: "Bearer " + token },
            };

            const response = await postCall(data);
            if (response?.data) {
                const result = response?.data?.products || response?.data || [];
                setProducts(result);
                return result;
            }
        } catch (err) {
            console.error(err);
            setError(err);
            setProducts([]);
            return [];
        } finally {
            setLoading(false);
        }
    }, []);

    return {
        products,
        loading,
        error,
        fetchProducts,
    };
};